import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AlgChannelService } from "./channel.service";
import { ApiVisa } from '../../../shared/api-visa.model';
import { Injectable } from "@angular/core";
import { Core2Config } from "../../../shared";

@Injectable({ providedIn: "root" })
export class SesEmailService extends AlgChannelService{
    constructor(httpClient: HttpClient) {
        super();
        this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "email/ses/send";
        this.endpointPath =Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "email/ses/send";
        this.httpClient = httpClient;
    }

    broadcastEmail(data: any, apiVisa: ApiVisa) {
        let url = this.apiUrl + '/broadcast';
        return this.httpClient.post(
            url,
            data,
            this.getMultiPartFormHttpHeader(apiVisa)
        );
    }

    public sendNewAttachmentEmail(data: FormData, apiVisa: ApiVisa) {
        const url = this.apiUrl + '/media/new-email';
        return this.httpClient.post(url, data, this.getHttpHeader(apiVisa));
    }

    getHeader(apiVisa) {
        let headers = new HttpHeaders({
            'tenant-code': apiVisa.tenantCode
        })
        return { headers: headers };
    }
}